import React from 'react';
import { Menu } from 'evergreen-ui';

const DashboardItemMenu = ({ onEditClick, onDeleteClick }: any) => {
  return (
    <Menu>
      <Menu.Group>
        <Menu.Item onSelect={onEditClick}>Edit item</Menu.Item>
        <Menu.Item intent="danger" onSelect={onDeleteClick}>
          Delete item
        </Menu.Item>
      </Menu.Group>
    </Menu>
  );
};

export default DashboardItemMenu;
